import { AdminTemplate, MerchantEndOfDayWithBalanceByDateComponent } from "../../components";

export const MerchantEndOfDayWithBalanceByDate = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "İşyeri Hak Ediş Bakiye Raporları",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={true}>
      <MerchantEndOfDayWithBalanceByDateComponent />
    </AdminTemplate>
  );
};
